import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectAllUserTypes } from '../store/slices/accounts/userTypes';
import { useLazyGetUserTypesQuery } from '../services/accountsApi';

export const useUserTypes = () => {
  const userTypes = useSelector(selectAllUserTypes);
  const [getUserTypes] = useLazyGetUserTypesQuery();

  useEffect(() => {
    if (!userTypes?.length) {
      getUserTypes();
    }
  }, []);

  return userTypes;
};

export default useUserTypes;
